module.exports = __webpack_public_path__ + "img/estrutura.a444d8a2.jpg";